import SocialProof from '@/components/common/SocialProof'
import { getTestimonialsByLanguage } from '@/content/testimonials'
import { stats } from '@/content/stats'
import { IconStarFilled } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import type { SocialProofConfig } from '@/content/quiz/types'

interface SocialProofBlockProps {
  config?: SocialProofConfig
  darkBackground?: boolean
  compact?: boolean
  className?: string
}

export function SocialProofBlock({
  config = {},
  darkBackground = false,
  compact = false,
  className = '',
}: SocialProofBlockProps) {
  const { t, i18n } = useTranslation()
  const { testimonials = false, ratings = false, stats: showStats = false } = config

  const testimonialsList = getTestimonialsByLanguage(i18n.language)

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {ratings && (
        <div className="flex items-center gap-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <IconStarFilled key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <span className="text-sm text-slate-600">
            {stats.rating.average} ({t('socialProof.ratingCount', { ratingCount: stats.rating.count.toLocaleString() })})
          </span>
        </div>
      )}
      {showStats && (
        <SocialProof darkBackground={darkBackground} />
      )}
      {testimonials && !compact && testimonialsList.length > 0 && (
        <div className="space-y-3">
          {testimonialsList.slice(0, 2).map((testimonial, i) => (
            <div key={i} className="bg-slate-50 rounded-lg p-4 text-sm text-slate-700">
              <div className="flex gap-1 mb-2">
                {[...Array(testimonial.rating)].map((_, j) => (
                  <IconStarFilled key={j} className="w-4 h-4 text-yellow-400" />
                ))}
              </div>
              <p>{testimonial.content}</p>
              <p className="font-medium text-slate-900 mt-2">{testimonial.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
